module.exports = __webpack_public_path__ + "static/media/galerija_2014 (19).a8f0d552.jpg";